export default __webpack_public_path__ + "1e1bde2a8193de5ab70bcbdadb415a8a.webp";